module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title30"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/e9780806537054_c01"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("I")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("MAN’S RECORD OF BELIEFS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780806537054_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("II")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("INTELLECTUAL RUBBISH")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780806537054_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("III")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("ATHEISM AND AGNOSTICISM")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780806537054_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("IV")]), _vm._v(" - "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("ON BEING OLD")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/e9780806537054_ftn01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56abe009","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780806537054_toc01.vue
// module id = 66
// module chunks = 0